import axios from "axios";
import { getToken, isAuthenticated } from "./local-storage";

const production =
  process.env.REACT_APP_SERVER_HOST_PRODUCTION ||
  "https://ibraflex.devmod.com.br/painel";
const development =
  process.env.REACT_APP_SERVER_HOST_DEVELOPMENT ||
  "http://localhost:3000/painel";

const serverKey =
  process.env.REACT_APP_SERVER_KEY || "a45ba35e-05c8-4c4e-8050-607011c81558";

const baseURL =
  process.env.NODE_ENV === "development" ? development : production;

const api = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
    chave: serverKey,
  },
});

api.interceptors.request.use(async (config) => {
  const token = getToken();

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      const { data } = error.response;
      if (!data.status && data.mensagem.toLowerCase() === "token inválido.") {
        if (isAuthenticated()) {
          localStorage.clear();
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
